import baseApi from "../baseApi"
import type { User } from "../auth"
import type {
  ChangeEmailPayload,
  GetUsersFilter,
  MeUser,
  ProfilePayload,
} from "./model"
import { setUser as setSentryUser } from "@/error"

const api = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getMe: build.query<MeUser | null, void>({
      query: () => "users/me",
      async onQueryStarted(_args, { queryFulfilled }) {
        try {
          const { data: me } = await queryFulfilled

          if (!me) {
            return
          }

          setSentryUser({
            id: me.id,
            ip_address: "{{auto}}",
            email: me.email ?? undefined,
            username: me.email ?? undefined,
          })
        } catch {
          // noop
        }
      },
    }),
    getUsers: build.query<User[], GetUsersFilter>({
      query: (params) => ({ url: "users", params }),
    }),
    changeEmail: build.mutation<MeUser, ChangeEmailPayload>({
      query: (body) => ({
        url: "email",
        method: "POST",
        body,
      }),
      async onQueryStarted(_args, { dispatch, queryFulfilled }) {
        try {
          const { data: me } = await queryFulfilled

          await dispatch(api.util.upsertQueryData("getMe", undefined, me))
        } catch {
          // noop
        }
      },
    }),
    updateProfile: build.mutation<MeUser, ProfilePayload>({
      query: (body) => ({
        url: "users/me",
        method: "PATCH",
        body,
      }),
      async onQueryStarted(_args, { dispatch, queryFulfilled }) {
        try {
          const { data: me } = await queryFulfilled

          await dispatch(api.util.upsertQueryData("getMe", undefined, me))
        } catch {
          // noop
        }
      },
    }),
  }),
})

export const {
  useGetMeQuery,
  useGetUsersQuery,
  useChangeEmailMutation,
  useUpdateProfileMutation,
} = api
